import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import { AutosuggestService } from '../autosuggest.service';
import { INgxMyDpOptions, IMyDateModel } from 'ngx-mydatepicker';
import { environment } from '../../environments/environment';
import { EventEmitter } from "@angular/core";
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';


@Component({
  selector: 'app-promotionalsms-report',
  templateUrl: './promotionalsms-report.component.html',
  styleUrls: ['./promotionalsms-report.component.css']
})
export class PromotionalsmsReportComponent implements OnInit {


  dataSource;
  displayedColumns = ['sno', 'service_category', 'actions'];
  p: number = 1;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;


  @ViewChild('fileInput') fileInput;
  private appURL: string = environment.apiUrl;
  private uploadURL: string = environment.uploadUrl;
  public myFocusTriggeringEventEmitter = new EventEmitter<boolean>();
  myOptions: INgxMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 }
    // This will disable dates starting from tomorrow
  };
  // Initialized to specific date (09.10.2018)
  model2: any = { date: { year: 2018, month: 10, day: 9 } };
  month1: any = {};
  wbetot_exp: any;
  mbetot_exp: any;
  model: any = {};
  user: any = {};
  results: any = {};
  currentUser: any = {};
  currentOrg: any;
  sessionData: any = {};
  searching = false;
  searchFailed = false;
  hideSearchingWhenUnsubscribed = new Observable(() => () => this.searching = false);
  certList: any = [];
  certificate: any = {};
  cert: any = {};
  contId: number;
  mask: any[] = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  tinmask: any[] = [/[0-9]/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  certmask: any[] = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  userType: number;
  showLoader: boolean;
  wbe_goal: number;
  mbe_goal: number;
  dataresult: any;
  content: any;
  constructor(
    private router: Router,
    private loginservice: LoginService,
    private Autosuggest: AutosuggestService,
    private _flashMessagesService: FlashMessagesService

  ) {
  }

  openCoverages = false;
  indexSelectedCoverage = 1;

  ngOnInit(): void {

    this.model['start_date'] = '';
    this.model['end_date'] = '';
    this.model['Status'] = ''
    this.model['f_name'] = ''
    this.model['MobileNumber'] = ''
    // this.displayedColumns = this.columnNames.map(x => x.id);
    this.getPromotionalSMSReport('');
  }

  onDateChanged(type, event: IMyDateModel): void {
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  getPromotionalSMSReport(data) {
    this.showLoader = true;
    this.loginservice.getPromotionalSMSReport(data)
      .subscribe(
        datas => {
          if (data['Data'].length > 0) {
            this.showLoader = false;
            if (datas['data'].length > 0) {
              this.dataresult = datas['data'];
            } else {
              this.dataresult = [];
            }
          }
        }, error => { alert('Network Error getPromotionalSMSReport API'); });
  }


  search() {

    let param = {
      SenderId: 'KALLCA',
      Message: 'Dear gokul,  Thank you for visiting The Kallos Care Unisex Salon We hope you enjoyed it! For your next visit Call: 9087766771 Map:http://surl.li/htthlk',
      MobileNumbers: 'KALLCA',
      TemplateId: 1107172051335754005,
      ApiKey: 'm68fHxp8/qmNZy3nn9To7acJHr54p6cD2wXS8LTa13E=',
      ClientId: '46ffffc2-a86d-495c-841b-ad498433f417'
    }

    // this.loginservice.senSMS(param)
    //   .subscribe(
    //     datas => {
    //       this.showLoader = false;
    //       if (datas['data'].length > 0) {
    //         this.dataresult = datas['data'];
    //       } else {
    //         this.dataresult = [];
    //       }
    //     });



    this.showLoader = true;
    let data = {
      start_date: this.model['start_date'],
      end_date: this.model['end_date'],
      Status: this.model['Status'],
      f_name: this.model['f_name'],
      MobileNumber: this.model['MobileNumber']
    };

    // this.loginservice.getPromotionalSMSReportSearch(data)
    //   .subscribe(
    //     datas => {
    //       this.showLoader = false;
    //       if (datas['data'].length > 0) {
    //         this.dataresult = datas['data'];
    //       } else {
    //         this.dataresult = [];
    //       }
    //     });

  }

  reset() {
    this.model['start_date'] = '';
    this.model['end_date'] = '';
    this.model['Status'] = ''
    this.model['f_name'] = ''
    this.model['MobileNumber'] = ''
    this.ngOnInit();
  }
}



// WEBPACK FOOTER //
// ./src/app/promotionalsms-report/promotionalsms-report.component.ts